import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface ProcedureTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  counts: { doctors: number; specialties: number };
}

const ProcedureTab: React.FC<ProcedureTabProps> = ({ tab, onChange, counts }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      <Tab value="main" label="Geral" />
      <Tab value="doctors" label={<CountLabel label="Médicos" count={counts.doctors} />} />
      <Tab value="specialties" label={<CountLabel label="Especialidades" count={counts.specialties} />} />
    </RecordTabs>
  );
};

export default ProcedureTab;
